import React from 'react';

import { Control } from '@vlabs/uikit';

import st from './GroupedCheckboxItem.module.sass';

interface ItemProps {
  value: string;
  label: string;
  rightSlot?: React.ReactNode;
  checked: boolean;
  disabled?: boolean;
  onToggle: (value: string, next: boolean) => void;
}

export function GroupedCheckboxItem({
  value,
  label,
  rightSlot = undefined,
  checked,
  disabled = false,
  onToggle,
}: ItemProps): React.JSX.Element {
  return (
    <div className={st.Item}>
      <Control.Checkbox
        checked={checked}
        disabled={disabled}
        label={label}
        onChangeValue={(next) => {
          onToggle(value, next);
          return true;
        }}
      />
      {!!rightSlot && <div className={st.RightSlot}>{rightSlot}</div>}
    </div>
  );
}
